"use client"

import { GetPageByRouteQuery } from "apollo"
import { useEffect, useState } from "react"
import { getBreadCrumbs, HistoryData, transformProperties } from "utils"
import Hero from "../Common/Hero"
import Gallery from "./Gallery"
import TimelineWrapper from "./TimelineWrapper"

type Props = {
  data: GetPageByRouteQuery
  locale: string
  historyData: HistoryData[]
}

const components = {
  heroBanner: () => import("../Common/Hero"),
}

export default function HistoryPage({ data, locale, historyData }: Props) {
  const [someState, setSomeState] = useState(false)
  const parsedData = data?.page?.properties || []
  const { blocks } = transformProperties(parsedData)
  const heroBanner = blocks?.blocks?.find(
    (block: any) => block.blockType === "heroBanner",
  )
  const gallery = blocks?.blocks?.find(
    (block: any) => block.blockType === "gallery",
  )
  const breadCrumbs = getBreadCrumbs(data, locale)
  useEffect(() => {
    const timer = setTimeout(() => {
      setSomeState(true)
    }, 1000)
    return () => clearTimeout(timer)
  }, [])
  return (
    <>
      <Hero data={heroBanner} breadCrumbs={breadCrumbs} />
      <TimelineWrapper data={historyData} />
      <Gallery data={gallery} />
    </>
  )
}
